'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'compass-drafting';
var width = 576;
var height = 512;
var aliases = ["drafting-compass"];
var unicode = 'f568';
var svgPathData = 'M336.3 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-19.6 91.7c-9 2.8-18.5 4.3-28.4 4.3s-19.4-1.5-28.4-4.3L190.4 306.4c29.7 13.9 62.9 21.6 97.9 21.6 85.8 0 160.8-46.6 201-116l41.5 24c-48.4 83.6-138.9 140-242.5 140-43.8 0-85.3-10.1-122.2-28l-89.1 152.1-12.1 20.7-41.4-24.2 12.1-20.7 89.3-152.5C92.7 300.2 65.7 270.4 45.8 236l41.5-24c15.8 27.2 36.9 51 61.9 69.7l69.8-119.2c-16.6-17.3-26.7-40.7-26.7-66.5 0-53 43-96 96-96s96 43 96 96c0 25.8-10.2 49.2-26.7 66.5L403 240c-12.5 10-26.3 18.3-41.1 24.8l-45.1-77zM541 475.9l12.1 20.7-41.4 24.2-12.1-20.7-64.7-110.6c14.4-7.2 28.2-15.4 41.2-24.6L541 475.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompassDrafting = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;